import React from 'react'
import styled, { ThemeProvider } from 'styled-components';
import ButtonLink from '../ButtonLink/ButtonLink';

const Alerta = styled.div`
        border: 1px solid transparent;
        border-radius: 0.25rem;
        position: relative;
        color: ${props  => props.theme.color};
        background-color: ${props  => props.theme.backgroundColor};
        border-color: ${props  => props.theme.borderColor};
        padding-bottom: 0;
        padding-top: 0;
        margin-bottom: 0;
    `;

const AlertaTitulo = styled.div`
    padding: 0;
    margin: 0;
    color: ${props  => props.theme.colorAlertaTitulo};
`;

const AlertaConfirmacion = ({ onClickConfirmar, onClickCancelar, textoBotonConfirmar, textoAlerta, color, ancho = "99%", size, className, ...rest } ) => {
    
    const getColorAlerta = (color) => {
        switch(color){
            case "secondary": return "#d4edda"; 
            case "warning": return "#ffc107"; 
            case "danger": return "#dc3545"; 
            case "dark": return "#343a40"; 
            case "info": return "#17a2b8";
            default: return "#155724";
        }
    };

    const getColorAlertaBorder = (color) => {
        switch(color){
            case "secondary": return "#d6d8db"; 
            case "warning": return "#ffc107"; 
            case "danger": return "#f5c6cb"; 
            case "dark": return "#343a40"; 
            case "info": return "#4aa1bb"; 
            default: return "#c3e6cb";
        }
    };

    const getColorBackground = (color) => {
        switch(color){
            case "secondary": return "#e2e3e5"; 
            case "warning": return "#ffc107"; 
            case "danger": return "#f8d7da"; 
            case "dark": return "#343a40"; 
            case "info": return "#5bc0de";
            default: return "#d4edda";
        }
    };

    const getColorAlertaTitulo = (color) => {
        switch(color){
            case "secondary": return "#6c757d"; 
            case "warning": return "#ffc107"; 
            case "danger": return "#721c24";
            case "dark": return "#343a40"; 
            case "info": return "#035096"; 
            default: return "#26844B";
        }
    };    

    return (
        <ThemeProvider theme={{ color: getColorAlerta(color), backgroundColor: getColorBackground(color), borderColor: getColorAlertaBorder(color), colorAlertaTitulo:getColorAlertaTitulo(color)}}>

            <Alerta color={color} {...rest} style={{width: ancho}} className={"d-flex flex-lg-row flex-column justify-content-center align-items-center " + (size !== "sm"?"py-1 ":"") + className} >
                
                <AlertaTitulo className="font-weight-normal text-center">{textoAlerta}</AlertaTitulo>
                
                <div className="justify-content-between justify-content-lg-center text-center">

                    <ButtonLink
                        onClick={onClickConfirmar}
                        className="ms-3 me-2"
                        color={color === "secondary" ? "dark" : color} 
                    >
                        {textoBotonConfirmar}
                    </ButtonLink>

                    <ButtonLink
                        onClick={onClickCancelar}
                        color="secondary"
                    >
                        Cancelar
                    </ButtonLink>

                </div>

            </Alerta>

        </ThemeProvider>
    )
}

export default AlertaConfirmacion